<div id="<%= modal_window_id %>" class="modal" tabindex="-1" role="dialog">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title"><%= title %></h5>
			</div>
			<div class="modal-body">
				<%- message %>
			</div>
			<div class="modal-footer">
				<button id="anvil-modal-confirm-ok-btn" type="button" class="btn btn-<%- btn_ok_class %>"><%- btn_ok %></button>
				<button id="anvil-modal-confirm-cancel-btn" type="button" class="btn btn-dark"><%- btn_cancel %></button>
			</div>
		</div>
	</div>
</div>
